// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__2KMc1","tabs":"Card_tabs__3wRua","nav":"Card_nav__2Soru","active":"Card_active__3FBi1"};